import * as styles from './styles';
import { UntactTvBanner } from '@api/GoodocAPI';

const BannerContent = (props: { banner: UntactTvBanner }) => {
  const { banner } = props;

  return (
    <div>
      <div css={styles.videoGradiant} />
      <div css={styles.contentWrapper}>
        <img src={banner.topImage} alt={banner.title} />
      </div>
    </div>
  );
};

export default BannerContent;
